export function shouldAutoRunCurrentCustomPageUpdate(prompt: string): boolean {
  const lowerPrompt = prompt.toLowerCase();

  if (
    /\b(start over|replace everything|rebuild|create a new dashboard|new dashboard|create a new page|new page)\b/.test(
      lowerPrompt
    ) ||
    /\b(create|build|make|generate)\b[^.!?]*\b(dashboard|page)\b/.test(
      lowerPrompt
    )
  ) {
    return false;
  }

  return (
    /\b(remove|delete|drop|take out|without)\b/.test(lowerPrompt) ||
    /\b(add|include|append|another|one more|extra|along with|plus|bring in)\b/.test(
      lowerPrompt
    ) ||
    /\balso\s+(add|include|append|show|bring in)\b/.test(lowerPrompt) ||
    /\b(show|include|add|append|bring in)\b[^.!?]*\b(too|as well)\b/.test(
      lowerPrompt
    ) ||
    /\b(replace|swap|change)\b/.test(lowerPrompt)
  );
}
